// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_n1-0";
export var discountCodeInput = "_n1-1";